import { render, staticRenderFns } from "./lose.vue?vue&type=template&id=01abfb54"
import script from "./lose.vue?vue&type=script&lang=js"
export * from "./lose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports